<template>
  <main>
    <div class="header"></div>
    <div class="bg">
      <div class="top-box"></div>
      <div class="register-box">
        <div class="title">报名参会</div>
        <div class="clear item" data-name="company">
          <div class="left tit">
            <div class="middle"><i>*</i>公司名称</div>
          </div>
          <div class="left input" v-click-outside="hiddenCompany">
            <input type="text" class="left in" :class="[error.company ? 'error' : '']" @blur="validate('company')"
                   placeholder="公司名称" v-model="form.company" @input="selectCompany">
            <div class="validate">{{ error.company }}</div>
            <div class="input-select" v-if="company_loading || company.length > 0">
              <div class="select-options" v-if="!company_loading">
                <div class="item" v-for="item in company" @click="chooseCompany(item)">{{ item }}</div>
              </div>
              <div class="loading" v-else>
                <van-loading/>
              </div>
            </div>
          </div>
        </div>
        <div class="clear item" data-name="username">
          <div class="left tit">
            <div class="middle"><i>*</i>姓名</div>
          </div>
          <div class="left input">
            <input type="text" class="left in" :class="[error.username ? 'error' : '']" @blur="validate('username')"
                   placeholder="姓名" v-model="form.username">
            <div class="validate">{{ error.username }}</div>
          </div>
        </div>
        <div class="clear item" data-name="email">
          <div class="left tit">
            <div class="middle"><i>*</i>邮箱</div>
          </div>
          <div class="left input">
            <input type="email" class="left in" :class="[error.email ? 'error' : '']" @blur="validate('email')"
                   placeholder="邮箱" v-model="form.email">
            <div class="validate">{{ error.email }}</div>
          </div>
        </div>
        <div class="clear item" data-name="phone">
          <div class="left tit">
            <div class="middle"><i>*</i>手机号</div>
          </div>
          <div class="left input">
            <input type="text" class="left in" :class="[error.phone ? 'error' : '']" @blur="validate('phone')"
                   placeholder="手机" v-model="form.phone" :readonly="is_new == 2 ? true : false">
            <div class="validate">{{ error.phone }}</div>
          </div>
        </div>
        <div class="clear item" data-name="code">
          <div class="left tit">
            <div class="middle"><i>*</i>验证码</div>
          </div>
          <div class="left input code">
            <input type="text" class="left in" :class="[error.code ? 'error' : '']"
                   @blur="validate('code');getEdmByPhone();" placeholder="请输入验证码" v-model="form.code">
            <span class="left btn" :class="code_status ? '' :'hidden'" @click="getCode">{{ code_text }}</span>
            <div class="validate">{{ error.code }}</div>
          </div>
        </div>

        <!--<div class="clear item" data-name="password" v-show="is_new != 2">
            <div class="left tit"><div class="middle"><i>*</i>密码</div></div>
            <div class="left input">
                <input type="password" class="left in" maxlength="20" :class="[error.password ? 'error' : '']" @blur="validate('password')" placeholder="请输入密码" v-model="form.password">
                <div class="validate">{{error.password}}</div>
            </div>
        </div>
        <div class="clear item" data-name="password2" v-show="is_new != 2">
            <div class="left tit"><div class="middle"><i>*</i>确认密码</div></div>
            <div class="left input">
                <input type="password" class="left in" maxlength="20" :class="[error.password2 ? 'error' : '']" @blur="validate('password2')" placeholder="请再次确认密码" v-model="form.password2">
                <div class="validate">{{error.password2}}</div>
            </div>
        </div>-->
        <!-- <div class="clear item item-select" data-name="rank">
             <div class="left tit"><div class="middle"><i>*</i>职级</div></div>
             <div class="left input" :class="[error.rank ? 'error' : '']">
                 <dell-select :option="select_option.rank" :value="form.rank" @setValue="setValue('rank',$event)"></dell-select>
             </div>
             <div class="validate">{{error.rank}}</div>
         </div> -->
        <div class="clear item item-select" data-name="position">
          <div class="left tit">
            <div class="middle"><i>*</i>职务</div>
          </div>
          <div class="left input" :class="[error.position ? 'error' : '']">
            <dell-select :option="select_option.position" :value="form.position"
                         @setValue="setValue('position',$event)"></dell-select>
          </div>
          <div class="validate">{{ error.position }}</div>
        </div>
        <!-- <div class="clear item item-check" data-name="rank_list" v-if="form.position">
            <div class="left tit"><div class="middle"><i>*</i>职能</div></div>
            <div class="left ll" v-for="i in rank_list" v-if="i.type == form.position">
                <label v-for="(ii,vv) in i.list"><input type="checkbox" v-model="form.rank_list" name="rank_list" :value="ii"><i></i><span>{{ii}}</span></label>
            </div>
            <div class="validate">{{error.rank_list}}</div>
        </div> -->
        <div class="clear item-wrap" data-name="province">
          <div class="clear item item-m item-left">
            <div class="left tit">
              <div class="middle"><i>*</i>省份</div>
            </div>
            <div class="left input" :class="[error.province ? 'error' : '']">
              <dell-select :option="province" :value="form.province"
                           @setValue="setValue('province',$event)"></dell-select>
            </div>
            <div class="validate">{{ error.province }}</div>
          </div>
          <div class="clear item item-m" data-name="city">
            <div class="left tit">
              <div class="middle"><i>*</i>城市</div>
            </div>
            <div class="left input" :class="[error.city ? 'error' : '']">
              <dell-select :option="city" :value="form.city" @setValue="setValue('city',$event)"></dell-select>
            </div>
            <div class="validate">{{ error.city }}</div>
          </div>
        </div>
        <div class="clear item item-select" data-name="industry">
          <div class="left tit">
            <div class="middle"><i>*</i>行业</div>
          </div>
          <div class="left input" :class="[error.industry ? 'error' : '']">
            <dell-select :option="select_option.industry" :value="form.industry"
                         @setValue="setValue('industry',$event)"></dell-select>
          </div>
          <div class="validate">{{ error.industry }}</div>
        </div>
        <div class="clear item item-select" data-name="identity">
          <div class="left tit">
            <div class="middle"><i>*</i>您的参会身份</div>
          </div>
          <div class="left input" :class="[error.identity ? 'error' : '']">
<!--            <template v-if="!assign_channel">-->
            <template v-if="is_offline">
              <dell-select :option="select_option.identity_offline" :value="form.identity"
                           @setValue="setValue('identity',$event)"></dell-select>
            </template>
            <template v-else>
              <dell-select :option="select_option.identity" :value="form.identity"
                           @setValue="setValue('identity',$event)"></dell-select>
            </template>

<!--            </template>-->
<!--            <template v-else>-->
<!--              <dell-select :option="select_option.identity2" :value="form.identity"-->
<!--                           @setValue="setValue('identity',$event)"></dell-select>-->
<!--            </template>-->
          </div>
          <div class="validate">{{ error.identity }}</div>
        </div>
        <div class="clear item item-check" data-name="forum" v-if="(is_offline && assign_channel || !is_offline)">
          <div class="left tit">
            <div class="middle"><i>*</i>您感兴趣的论坛（多选）</div>
          </div>
          <div class="left ll forum-list" :class="[form.identity === '合作伙伴' ? 'active' : '']">
<!--            <template v-if="!assign_channel">-->
              <template v-if="form.identity === '合作伙伴'">
                <div class="li" v-for="(item,index) in select_option.forum2" :class="[checkForum(item) ? 'active' : '', error.forum ? 'error' : '']"
                     @click="chooseForum(item)">
                  <div class="text" v-html="item.title"></div>
                  <div class="text">({{ item.time }})</div>
                  <div class="desc">{{ item.desc }}</div>
                  <div class="tips" v-if="item.tips">{{ item.tips }}</div>
                </div>
              </template>
<!--              <template v-else-if="form.identity === '戴尔员工'">-->
<!--                <div class="li" v-for="(item,index) in select_option.forum3" :class="[checkForum(item) ? 'active' : '']"-->
<!--                     @click="chooseForum(item)">-->
<!--                  <div class="text" v-html="item.title"></div>-->
<!--                  <div class="text">({{ item.time }})</div>-->
<!--                  <div class="desc">{{ item.desc }}</div>-->
<!--                </div>-->
<!--              </template>-->
              <template v-else>
                <div class="li" v-for="(item,index) in select_option.forum" :class="[checkForum(item) ? 'active' : '', error.forum ? 'error' : '']"
                     @click="chooseForum(item)">
                  <div class="text" v-html="item.title"></div>
                  <div class="text">({{ item.time }})</div>
                  <div class="desc">{{ item.desc }}</div>
                  <div class="tips" v-if="item.tips">{{ item.tips }}</div>
                </div>
              </template>
<!--            </template>-->
<!--            <template v-else>-->
<!--              <div class="li" v-for="(item,index) in select_option.forum4" :class="[checkForum(item) ? 'active' : '']"-->
<!--                   @click="chooseForum(item)">-->
<!--                <div class="text" v-html="item.title"></div>-->
<!--                <div class="text">({{ item.time }})</div>-->
<!--                <div class="desc">{{ item.desc }}</div>-->
<!--              </div>-->
<!--            </template>-->
          </div>
          <div class="validate">{{ error.forum }}</div>
        </div>
        <!--<div class="clear item item-select" data-name="people">
           <div class="left tit"><div class="middle"><i>*</i>公司人数</div></div>
           <div class="left input" :class="[error.people ? 'error' : '']">
               <dell-select :option="select_option.people" :value="form.people" @setValue="setValue('people',$event)"></dell-select>
           </div>
           <div class="validate">{{error.people}}</div>
       </div>
       <div class="clear item item-select item-lang">
           <div class="left tit"><div class="middle"><i>*</i>贵公司目前是否有采购IT产品的计划</div></div>
           <div class="left input" :class="[error.plan ? 'error' : '']">
               <dell-select :option="select_option.plan" :value="form.plan" @setValue="setValue('plan',$event)"></dell-select>
           </div>
           <div class="validate">{{error.plan}}</div>
       </div>
       <div class="clear item item-select item-lang" data-name="buy">
           <div class="left tit"><div class="middle"><i>*</i>您的预算</div></div>
           <div class="left input" :class="[error.buy ? 'error' : '']">
               <dell-select :option="select_option.buy" :value="form.buy" @setValue="setValue('buy',$event)"></dell-select>
           </div>
           <div class="validate">{{error.buy}}</div>
       </div>
       <div class="clear item item-select item-lang" data-name="product">
           <div class="left tit"><div class="middle"><i>*</i>您感兴趣的产品</div></div>
           <div class="left input" :class="[error.product ? 'error' : '']">
               <dell-select :option="select_option.product" :value="form.product" @setValue="setValue('product',$event)"></dell-select>
           </div>
           <div class="validate">{{error.product}}</div>
       </div>
       <div class="clear item item-select item-lang" data-name="case">
           <div class="left tit"><div class="middle"><i>*</i>您感兴趣的解决方案</div></div>
           <div class="left input" :class="[error.case ? 'error' : '']">
               <dell-select :option="select_option.case" :value="form.case" @setValue="setValue('case',$event)"></dell-select>
           </div>
           <div class="validate">{{error.case}}</div>
       </div>
       <div class="clear item item-select item-lang" data-name="role">
           <div class="left tit"><div class="middle"><i>*</i>您在公司的决策中扮演什么样的角色</div></div>
           <div class="left input" :class="[error.role ? 'error' : '']">
               <dell-select :option="select_option.role" :value="form.role" @setValue="setValue('role',$event)"></dell-select>
           </div>
           <div class="validate">{{error.role}}</div>
       </div>
       <div class="clear item item-select item-lang" data-name="description">
           <div class="left tit"><div class="middle">项目描述</div></div>
           <div class="left input">
               <input type="text" class="left in" placeholder="项目描述" v-model="form.description">
           </div>
           <div class="validate"></div>
       </div>-->
        <!-- <div class="check-box item-select">
            <div class="tit"><i class="red">*</i>更多解决方案或产品方面的问题，您是否愿意接受戴尔易安信销售/合作伙伴与您联系？</div>
            <div class="check">
                <label><input type="radio" v-model="form.agree_contact" name="receive_message" value="1"><i></i><span>是</span></label>
                <label><input type="radio" v-model="form.agree_contact" name="receive_message" value="2"><i></i><span>否</span></label>
            </div>
            <div class="validate">{{error.agree_contact}}</div>
        </div> -->
<!--        <div class="clear item item-select" data-name="attend_dinner" v-if="form.identity == '合作伙伴'">-->
<!--          <div class="left tit">-->
<!--            <div class="middle"><i>*</i>是否参加合作伙伴晚宴</div>-->
<!--          </div>-->
<!--          <div class="left input" :class="[error.attend_dinner ? 'error' : '']">-->
<!--            <div class="check-box item-select" style="padding-left: 0">-->
<!--              <div class="check">-->
<!--                <label><input type="radio" v-model="form.attend_dinner" name="receive_message" value="是"><i></i><span>是</span></label>-->
<!--                <label><input type="radio" v-model="form.attend_dinner" name="receive_message" value="否"><i></i><span>否</span></label>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="validate">{{ error.attend_dinner }}</div>-->
<!--        </div>-->

        <div class="rule-box item-select" data-name="rule">
          <div class="tit">
            <label><input type="checkbox" @change="validate('rule')" v-model="form.rule" name="agree"><i class="i"></i>
              <span style="font-size: 14px;">我了解并同意以下内容：戴尔按照<a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" style="color: #007db8;">《隐私声明》</a>所述，根据《个人信息保护法》的规定，将本人个人信息传输、存储至戴尔美国总部进行处理。要详细了解戴尔如何使用、共享和保护您的个人数据，请参阅我们的 <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" style="color: #007db8;">隐私声明</a>。<br><div class="privacy-statement-text" style="margin-top: 10px;">单击"立即报名"，即表示您同意 <a target="_blank" rel="noopener noreferrer" href="https://investors.delltechnologies.com/node/11831/html" style="color: #007db8;">Dell Technologies 及其公司集团</a>（简称"戴尔"）通过电子邮件、电话或短信与您保持联系。戴尔及其销售代表将向您提供有关产品、服务、解决方案、专享优惠和特别活动的最新信息。有关信息处理方式的更多详细信息，请参见我们的 <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" style="color: #007db8;">隐私声明</a>。您可以随时取消订阅。</div></span>
            </label>
          </div>
          <div class="validate">{{ error.rule }}</div>
        </div>
        <div class="submit" @click="submit">立即报名</div>
      </div>
    </div>
    <div class="book-success" v-if="book_success">
      <div class="mark"></div>
      <div class="content">
        <!-- 临时修改 -->
        <div class="close" v-if="false" @click="toBack"></div>
        <div class="middle">
          <div class="title">{{ book_info.title }}</div>
          <div class="m-title" v-html="book_info.desc"></div>
          <div class="qrcode-box">
            <template v-if="is_offline">
              <img src="@/assets/image/2024/qrcode01.jpg" alt="" class="qrcode">
              <div class="info">关注享多重好礼<br/>好礼一：申领大会资料<br/>好礼二：免费抽奖，100%中</div>
            </template>
            <template v-else>
              <img src="@/assets/image/2024/qrcode01.jpg" alt="" class="qrcode">
              <div class="info">关注享多重好礼<br/>好礼一：直播预约通知<br/>好礼二：申领大会资料<br/>好礼三：免费抽奖，100%中</div>
            </template>
          </div>
          <template>
            <div class="btn-group">
              <div class="btn" @click="util.toLink('/')">确定</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <service></service>
  </main>
</template>

<script>
import DellSelect from "../../components/pc/DellSelect";
import Service from "../../components/pc/Service";
import {companySelect} from "@/data/api";
import {Loading as VanLoading} from "vant";
import util from "@/common/util";

export default {
  name: 'edm',
  data() {
    return {
      query: "",
      form: {
        company: "",
        province: "",
        agree_contact: '是',
        position: "",
        identity: "",
        rank_list: [],
        forum: ["主会场 - 进化·乘势而上"],
        ifWish: "是",
        // attend_dinner: "",
      },
      company: [],
      company_loading: false,
      timeout: false,
      province: [],
      city: [],
      code_text: "获取验证码",
      code_status: true,
      is_new: false,
      error: {},
      book_success: false,
      book_info: {
        title: "您已报名",
        desc: "期待您在2026年08月21日参加 <br/>2026戴尔科技峰会"
      },
      // book_success:true,
      // book_info:{
      // 	title:"您已报名",
      // 	desc:"期待您参加<br/>新·生万物 数实新格局 | 2023 戴尔科技峰会" ,
      // },
      // logo: [require('@/assets/image/49.png'), require('@/assets/image/50.png')],
    }
  },
  components: {
    Service,
    DellSelect,
    VanLoading
  },
  computed: {
    channel() {
      return this.tool.storage.getLocal("channel") || "";
    },
    assign_channel() {
      const channel = this.tool.other.getUrlParams('channel');
      if (channel) {
        return channel.indexOf('sh-offline') != -1;
      } else {
        return true;
      }
    },
    form_identity() {
      return this.form.identity;
    },
    is_offline() {
      return this.util.isOffline();
    },
    select_option() {
      return {

        // rank:["高级管理层","管理层","工程师/技术专家","其他"],
        // position:["信息技术","高级行政","财务/采购","生产运维","办公室行政","客服/技术支持","媒体/出版","其他"],
        position: ["CxO及以上", "IT总监或IT负责人", "IT经理或IT技术人员", "业务负责人", "设计/研发部门人员", "IT采购人员/负责人", "行政人员", "其他职位"],

        industry: ["互联网相关企业", "IT服务业", "物流运输业", "其他服务行业", "高科技制造业", "普通制造业", "金融行业", "批发零售业", "电信", "媒体、娱乐", "能源", "政府、事业单位", "医疗行业", "教育行业", "房地产", "其他"],
        people: ['1-25', '26-99', '100-499', '500-999', '1000-4999', '5000-9999', '10000+'],
        plan: ['<3 月', '3-6 月', '6-12 月', '>12 月', "无计划"],
        buy: ["5万以下", "5万-10万", "10万-30万", "30万-50万", "50万-100万", "100万以上", "无计划"],
        product: ["商用笔记本", "商用台式机", "工作站", "服务器", "网络交换机", "数据存储", "数据保护", "超融合架构", "显示器及外设设备"],
        case: ["云计算", "软件定义", "大数据", "融合/超融合", "数据库加速", "高性能计算", "业务连续性", "桌面虚拟化", "数据保护", "咨询服务", "VR解决方案", "灵活桌面解决方案", "移动办公解决方案", "智能会议解决方案", "戴尔硬盘保护套件",],
        role: ["决策者", "影响者", "建议者",],
        identity: ["客户", "合作伙伴", "戴尔员工"],
        identity_offline: ["客户", "合作伙伴", "戴尔员工", "展区工作人员", "媒体", "分论坛演讲嘉宾", "赞助商"],
        identity2: ["客户", "戴尔员工", "媒体", "分论坛演讲嘉宾"],
        forum: [
          {
            title: "主会场 - 进化·乘势而上",
            time: "9:00-12:00",
            desc: "本届峰会聚焦企业级 AI 从 “技术探索期” 迈向 “规模应用与价值兑现期” 的关键节点，探讨中国企业在全球化深水区面临的数字化转型挑战与破局路径。将从推动 AI 落地见效、重构成本模型、打造 AI 原生工作方式、构建可信智能体系、夯实全球化数字化底座五大维度。与来自各行业的领军企业决策者与技术领袖，共同洞察AI驱动下的更优「进化路径」，把握下一阶段增长的主动权。"
          },
          {
            title: "分会场 - 智能触手可及：重新定义 AI 的运行方式与生产力未来",
            time: "13:30-17:30",
            desc: "AI 正在重塑工作的方式。它不再只栖身于云端，而是走向设备端与混合运行，真正抵达每一位员工的桌面。这既是技术的跃迁，更是生产力格局的重构。\n在本分论坛中，戴尔科技携手多家合作伙伴，将桌面级智能体 AI 带入企业的每一张办公桌: 在这里，您将看到两年内最高降低 87% 的 Token 支出，感受业界最安全、最易管理的商用 AI PC，以及戴尔与各大合作伙伴共同构筑的混合 AI 生产力。从掌控到规模，从成本到成效，让我们携手同行，推动业务坚定向前。"
          },
          {
            title: "分会场 - 从解耦到智能：重塑现代化基础架构",
            time: "13:30-16:30",
            desc: '面对智能技术浪潮加速、多云环境交织、网络威胁持续升级的复杂现实,企业正站在基础架构变革的关键节点。本分会场将从戴尔科技的"解耦架构、智能就绪、网络弹性"三大核心战略出发,深度解析如何以解耦式架构重塑数据中心根基、以智能原生数据平台释放数据价值、以内生式安全体系筑牢业务韧性。现场同时邀请战略合作伙伴带来前沿视角与联合解决方案分享,共同勾勒面向未来的企业IT演进蓝图。'
          }
        ],
        forum2: [
          {
            title: "主会场 - 进化·乘势而上",
            time: "9:00-12:00",
            desc: "本届峰会聚焦企业级 AI 从 “技术探索期” 迈向 “规模应用与价值兑现期” 的关键节点，探讨中国企业在全球化深水区面临的数字化转型挑战与破局路径。将从推动 AI 落地见效、重构成本模型、打造 AI 原生工作方式、构建可信智能体系、夯实全球化数字化底座五大维度。与来自各行业的领军企业决策者与技术领袖，共同洞察AI驱动下的更优「进化路径」，把握下一阶段增长的主动权。"
          },
          {
            title: "合作伙伴峰会 - 同行·乘势而上",
            time: "14:00-17:35",
            desc: "同行聚力，乘势致远。面对企业数字化深化与全球化布局的双重挑战，戴尔科技将精准洞察IT市场变革与高潜行业机遇，坚定与合作伙伴并肩同行，以全栈能力与生态合力，共探数字化时代增长新边界，拆解销售协同与伙伴计划的成功密码，携手为客户交付面向未来的数智化转型方案。",
            tips: "*仅限戴尔科技官方授权合作伙伴参会，席位有限，先到先得！"
          }
        ]
      }
    },
    rank_list() {
      return [
        {
          type: "信息技术",
          list: ['硬件管理及维护', '网络管理及维护', '桌面运维', 'IT架构设计', '应用软件研发', '软件管理/维护', '信息安全/保护/灾备', 'DBA/数据库', '数据中心/数据中台', '数据建模/挖掘/分析', '大数据架构', '项目管理', 'BI/商业智能', '人工智能', '通讯', '其他']
        },
        {type: "高级行政", list: ['董事会', 'CEO', '总裁', '总经理', '其他']},
        {type: "财务/采购", list: ['财务', '采购', '供应商管理', '其他']},
        {type: "生产运维", list: ['供应链管理', '产线管理', '质量监控', '其他']},
        {type: "办公室行政", list: ['办公室主任', '总裁助理/总经理助理/董事会秘书', '行政总监/经理', '其他']},
        {type: "客服/技术支持", list: ['售前技术支持', '售后技术支持', '实施顾问', '咨询热线/呼叫中心', '客户服务', '其他']},
        {type: "媒体/出版", list: ['编辑', '记者', '出版发行', '其他']},
        {type: "其他", list: ['其他']},
      ]
    },
    form_province() {
      return this.form.province;
    },
    form_position() {
      return this.form.position;
    },
    form_rank_list() {
      return this.form.rank_list;
    },
    form_forum() {
      return this.form.forum;
    },
    form_agree_contact() {
      return this.form.agree_contact
    },
    form_attend_dinner() {
      return this.form.attend_dinner;
    }
  },
  watch: {
    form_position() {
      this.form.rank_list = [];
    },
    form_rank_list() {
      this.validate('rank_list');
    },
    form_forum() {
      this.validate('forum');
    },
    form_agree_contact() {
      this.validate('agree_contact');
    },
    form_identity(val) {
      // 切换身份时重置默认选中：合作伙伴默认选中 forum2 全部，其他身份默认选主会场
      if (val === '合作伙伴') {
        this.form.forum = this.select_option.forum2.map(item => item.title);
      } else {
        this.form.forum = ["主会场 - 进化·乘势而上"];
      }
    },
    form_attend_dinner() {
      this.validate('attend_dinner');
    },

  },
  created() {
    const channel = this.channel;
    if (this.$store.state.user_info.phone) this.form.phone = this.$store.state.user_info.phone;
  },
  methods: {
    toShenzhen() {
      window.open('https://www.dellemc-solution.com/u/w1trqn4', '_blank')
    },
    toShanghai() {
      window.open('https://www.dellemc-solution.com/u/lqduwe3', '_blank')
    },
    checkForum(item) {
      return this.form.forum.indexOf(item.title) > -1;
    },
    chooseForum(item) {
      if (this.checkForum(item)) {
        const index = this.form.forum.indexOf(item.title);
        this.form.forum.splice(index, 1)
      } else {
        this.form.forum.push(item.title);
        // 时间冲突的分会场互斥：只能选一个
        var mutex = {
          "分会场 - 智能触手可及：重新定义 AI 的运行方式与生产力未来": "分会场 - 从解耦到智能：重塑现代化基础架构",
          "分会场 - 从解耦到智能：重塑现代化基础架构": "分会场 - 智能触手可及：重新定义 AI 的运行方式与生产力未来",
        };
        if (mutex[item.title]) {
          var i = this.form.forum.indexOf(mutex[item.title]);
          if (i > -1) {
            this.form.forum.splice(i, 1);
          }
        }
      }
    },
    hiddenCompany() {
      this.company = [];
    },
    selectCompany() {
      if (!this.form.company || this.form.company.length <= 1) {
        return false;
      }
      this.company_loading = true;
      var wait = 500;
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          this.timeout = null;
          companySelect(this.form.company).then((res) => {
            this.company = res.company;
          }).finally(() => {
            this.company_loading = false;
          })
        }, wait)
      }
    },
    chooseCompany(item) {
      this.form.company = item;
      this.hiddenCompany();
    },
    getEdmByPhone() {
      if (!this.is_new) {
        this.setError('code', '验证码错误');
        return false;
      }
      if (this.is_new == 1) {
        return false;
      }
      if (this.validate('phone') && this.validate('code')) {
        this.http.request({
          api: "auth/getEdmByPhone",
          data: {
            phone: this.form.phone,
            code: this.form.code
          },
          loading: true,
          success: (res) => {
            var user_thumb = res.user;
            //this.form.username = user_thumb.name;
            //this.form.phone = user_thumb.mobile;
            // this.form.email = user_thumb.email;
            // this.form.company = user_thumb.enterprise_name;
            // this.form.rank = user_thumb.joblevel ? user_thumb.joblevel[0] :'';
            this.form.position = user_thumb.jobfunction ? user_thumb.jobfunction[0] : '';
            this.form.province = user_thumb.province && user_thumb.province[0] ? {title: user_thumb.province[0]} : '';
            this.form.city = user_thumb.province && user_thumb.province[1] ? {title: user_thumb.province[1]} : '';
            this.form.industry = user_thumb.industry ? user_thumb.industry[0] : '';
            this.form.people = user_thumb.employeesNumber ? user_thumb.employeesNumber[0] : '';
            this.form.plan = user_thumb.m_buyPlan ? user_thumb.m_buyPlan[0] : '';
            this.form.buy = user_thumb.m_buyBudget ? user_thumb.m_buyBudget[0] : '';
            this.form.product = user_thumb.m_interestProduct ? user_thumb.m_interestProduct[0] : '';
            this.form.case = user_thumb.m_solutionType ? user_thumb.m_solutionType[0] : '';
            this.form.role = user_thumb.m_companyRole ? user_thumb.m_companyRole[0] : '';
            this.form.description = user_thumb.m_isummary;

            this.form.password = user_thumb.password;
            this.form.memberId = user_thumb.memberId;
            this.form.loginId = user_thumb.loginId;
            this.form.session = user_thumb.session;
            this.form.sess = user_thumb.sess;
            if (this.form.position) {
              if (this.select_option.position.indexOf(this.form.position) == -1) {
                this.form.position = "";
              }
            }
            if (this.form.industry) {
              if (this.select_option.industry.indexOf(this.form.industry) == -1) {
                this.form.industry = "";
              }
            }
            this.$forceUpdate();
            this.$nextTick(() => {
              this.form.rank_list = user_thumb.jobfunctionrole && this.tool.type.isArray(user_thumb.jobfunctionrole) ? user_thumb.jobfunctionrole[0].split(',') : [];
              this.$forceUpdate();
              this.error = {};
            })
          },
          error: (res) => {
            if (res.msg == '已报名') {
              // this.book_info = {
              //   title: "您已报名",
              //   desc: this.is_offline ? "期待您参加<br/>新·生万物 数实新格局 | 2024 戴尔科技峰会" : "期待您在2024年08月18日参加<br/>新·生万物 数实新格局 | 2024 戴尔科技峰会",
              // }
              this.book_info.title = "您已报名";
              this.book_success = true;
              this.util.setAccessToken(res.data.access_token);
              this.http.request({
                api: 'user/getUserInfo',
                success: (res) => {
                  // 登录用户变量
                  var gioParams = {
                    // area_ppl: (res.user.province + res.user.city) || "",//省份,城市
                    //companyName_ppl: res.user.company || "",//公司名称
                    //companyScale_ppl: "",//公司规模
                    //email_ppl: res.user.email || "",//邮箱
                    //industry_ppl: res.user.job || "",//行业
                    //phone_ppl: res.user.phone || "",//手机
                    //userName_ppl: res.user.username || "",//姓名
                    //userRole_ppl: "",//职位
                  };
                  gio('people.set', gioParams);
                  //登录用户ID
                  gio('setUserId', res.user.id);
                  //登录用户类型
                  gio('track', 'loginSuccess', {
                    'user_Id': res.user.memberId,  // memberId
                    'phoneNumber': util.encryptPhone(res.user.phone), //登录手机号
                    'loginType': '短信' // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
                  })
                  // console.log(1,res.user);
                  this.$store.commit('setUserInfo', res.user);
                  this.util.setDellCookie();
                }
              })
            } else {
              this.$toast.fail(res.msg);
            }
          }
        })
      }
    },
    validate(field, name = "") {
      var message = "";
      switch (field) {
        case 'phone':
          if (!this.form.phone) {
            message = "请输入手机号";
          } else if (this.isCn() && !this.tool.type.checkStr(this.form.phone, 'phone')) {
            message = "请输入正确的手机号";
          } else {
            message = "";
          }
          break;
        case 'code':
          if (!this.form.code) {
            message = "请输入验证码";
          } else if (this.form.code.length != 6) {
            message = '验证码不正确';
          } else {
            message = "";
          }
          break;
        case 'username':
          if (!this.form.username) {
            message = "请输入姓名";
          } else {
            message = "";
          }
          break;
        case 'email':
          if (!this.form.email) {
            message = "请输入邮箱";
          } else if (!this.tool.type.checkStr(this.form.email, 'email')) {
            message = "请输入正确的邮箱";
          } else {
            message = "";
          }
          break;
        case 'password':
          if (!this.form.password) {
            message = "请输入密码";
          } else if (this.form.password.length < 6) {
            message = "请输入6-20个字符";
          } else {
            message = "";
          }
          break;
        case 'password2':
          if (!this.form.password2) {
            message = "请再次确认密码";
          } else if (this.form.password !== this.form.password2) {
            message = "两次输入的密码不一致";
          } else {
            message = "";
          }
          break;
        case 'company':
          if (!this.form.company) {
            message = "请输入公司名称";
          } else {
            message = "";
          }
          break;
        case 'select':
          if (!this.form[name]) {
            message = "请选择";
          } else {
            message = "";
          }
          break;
        case 'rule':
          if (!this.form.rule) {
            message = "请先阅读并同意戴尔隐私声明和销售条款";
          } else {
            message = "";
          }
          break;
        case 'agree_contact':
          if (!this.form.agree_contact) {
            message = "请选择";
          } else {
            message = "";
          }
          break;
        case 'rank_list':
          if (this.form.rank_list && this.form.rank_list.length <= 0) {
            message = "请选择";
          } else {
            message = "";
          }
          break;
        case 'forum':
          if (this.form.forum && this.form.forum.length <= 0) {
            message = "请选择您感兴趣的论坛";
          } else {
            message = "";
          }
          break;
        case 'attend_dinner':
          if (!this.form.attend_dinner && this.form.identity == "合作伙伴") {
            message = "请选择是否参加合作伙伴晚宴";
          } else {
            message = "";
          }
          break;
        default:
          break;
      }
      this.setError(name ? name : field, message);
      return message ? false : true;
    },
    validateAll() {
      var company = this.validate('company');
      var username = this.validate('username');
      var email = this.validate('email');
      var phone = this.validate("phone");
      var code = this.validate('code');
      var password = this.validate('password');
      var password2 = this.validate('password2');
      var rank = this.validate('select', 'rank');
      var position = this.validate('select', 'position');
      var rank_list = this.validate('rank_list');
      var province = this.validate('select', 'province');
      var city = this.validate('select', 'city');
      var industry = this.validate('select', 'industry');
      var identity = this.validate('select', 'identity');
      var people = this.validate('select', 'people');
      var plan = this.validate('select', 'plan');
      var buy = this.validate('select', 'buy');
      var product = this.validate('select', 'product');
      var cases = this.validate('select', 'case');
      var forum = this.validate('forum');
      var role = this.validate('select', 'role')
      var agree_contact = this.validate('agree_contact')
      var attend_dinner = this.validate('attend_dinner')
      var rule = this.validate('rule')
      if (this.is_new == 2) {
        let isV = !company || !username || !email || !phone || !code || !rule || !position || !province || !city || !industry || !identity;
        if (this.is_offline && this.assign_channel || !this.is_offline) {
          isV = !company || !username || !email || !phone || !code || !rule || !position || !province || !city || !industry || !identity || !forum;
        }
        if (isV) {
          this.$nextTick(() => {
            this.scrollError();
          })

          return false;
        } else {
          return true;
        }
      } else {
        let isV = !company || !username || !email || !phone || !code || !rule || !position || !province || !city || !industry || !identity;
        if (this.is_offline && this.assign_channel || !this.is_offline) {
          isV = !company || !username || !email || !phone || !code || !rule || !position || !province || !city || !industry || !identity || !forum;
        }
        if (isV) {
          this.$nextTick(() => {
            this.scrollError();
          })
          return false;
        } else {
          return true;
        }
      }
    },
    scrollError() {
      var list = $('.validate');
      for (var i = 0; i < list.length; i++) {
        if ($(list[i]).text().length > 0) {
          $('body,html').scrollTop($(list[i]).parent().offset().top - 100)
          break;
        }
      }
    },
    setError(name, message = "") {
      this.error[name] = message;
      this.$forceUpdate();
    },
    submit() {

      // if(!this.is_new){
      //     this.setError('code','验证码错误');return false;
      // }

      var form = this.form;
      form.province_title = this.form.province ? this.form.province.title : '';
      form.city_title = this.form.city ? this.form.city.title : '';
      form.url = window.location.href;
      form.guest_id = this.util.getGuestUid();
      form.sellerID = this.getSellerId();

      if (this.tool.storage.getLocal('channel')) {
        form.channel = this.tool.storage.getLocal('channel');
      }
      form.huiyileixing = this.util.isOffline() ? '线下会' : '线上会';

      var res = this.validateAll();
      if (!res) {
        return false;
      }
      var api = "auth/registerForEn";
      if (this.isCn()) {
        api = "auth/register";
      }
      // console.log("submit",form);
      gio('track', 'DTF2021_SignupSubmit', {
        // 'userName':form.username,
        // 'phoneNumber':form.phone,
        // 'company' : form.company,
        // 'email' :form.email,
      });

      this.http.request({
        api: api,
        data: form,
        loading: true,
        success: (res) => {
          // this.book_info = {
          //   title: "您已报名",
          //   desc: this.is_offline ? "期待您参加<br/>新·生万物 数实新格局 | 2024 戴尔科技峰会" : "期待您在2024年08月18日参加<br/>新·生万物 数实新格局 | 2024 戴尔科技峰会",
          // }
          this.book_info.title = "您已报名";
          this.book_success = true;
          this.util.setAccessToken(res.access_token);
          this.getUserInfo();
        },
        error: (res) => {
          this.$toast.fail(res.msg);
        }
      })
    },
    getSellerId() {
      var seller_id = this.tool.other.getUrlParams('sid');
      if (!seller_id) {
        seller_id = this.tool.storage.getCookie('sellerID')
      }
      return seller_id;
    },
    getUserInfo() {
      this.http.request({
        api: 'user/getUserInfo',
        loading: true,
        success: (res) => {
          // 登录用户变量
          var gioParams = {
            // area_ppl: (res.user.province + res.user.city) || "",//省份,城市
            // companyName_ppl: res.user.company || "",//公司名称
            // companyScale_ppl: "",//公司规模
            // email_ppl: res.user.email || "",//邮箱
            // industry_ppl: res.user.job || "",//行业
            // phone_ppl: res.user.phone || "",//手机
            // userName_ppl: res.user.username || "",//姓名
            // userRole_ppl: "",//职位
          };
          gio('people.set', gioParams);
          //登录用户ID
          gio('setUserId', res.user.id);
          //登录用户类型
          gio('track', 'loginSuccess', {
            'user_Id': res.user.memberId,  // memberId
            'phoneNumber': util.encryptPhone(res.user.phone),  //登录手机号
            'loginType': '短信' // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
          })
          // console.log(2,res.user);
          this.$store.commit('setUserInfo', res.user);
          this.util.setDellCookie();
          //this.toBack();
        }
      })
    },
    toBack() {
      var backUrl = this.tool.other.getUrlParams('backUrl');
      if(backUrl){
          backUrl = decodeURIComponent(backUrl);
          window.location = backUrl;
          return;
      }
      this.book_success = false;
      // 根据线上线下状态进行不同跳转
      if(this.util.isOffline()){
        // 线下活动跳转到线下活动页面
        this.util.toLink('/offline');
      } else {
        // 线上活动跳转到首页
        this.util.toLink('/');
      }
    },
    setValue(key, value) {
      this.form[key] = value;
      if (key == 'province') {
        this.form.city = "";
        this.city = [];
        if (value) {
          this.getCity();
        }
      }
      this.validate('select', key);
      this.$forceUpdate();
    },
    getProvince() {
      this.http.request({
        api: "area/dell_province",
        success: (res) => {
          this.province = res.province;
        }
      })
    },
    getCity() {
      this.http.request({
        api: "area/dell_city",
        data: {
          province_id: this.form.province.id
        },
        success: (res) => {
          this.city = res.city;
        }
      })
    },
    checkNewUser(callback) {
      var phone = this.validate("phone");
      if (!phone) {
        return false;
      }
      this.http.request({
        api: "user/checkNewUser",
        data: {
          phone: this.form.phone,
          guest_id: this.util.getGuestUid()
        },
        //loading:true,
        success: (res) => {
          this.is_new = res.is_new;
          callback.call();
        }
      })
    },
    getCode() {
      if (!this.code_status) {
        return false;
      }
      var phone = this.validate("phone");
      if (!phone) {
        return false;
      }

      this.cutTime();
      this.checkNewUser(() => {
        if (!this.is_new) {
          return false;
        }

        var api = "sms/registerForEn";
        if (this.isCn()) {
          api = "sms/register"
        }
        if (this.is_new == 2) {
          api = "sms/loginForEn";
          if (this.isCn()) {
            api = "sms/login"
          }
        }
        this.http.request({
          api: api,
          data: {
            phone: this.form.phone
          },
          //loading:true,
          success: (res) => {
            //this.cutTime();
          },
          error: (res) => {
            this.setError('phone', res.msg)
            clearInterval(this.timer);
            this.code_text = "获取验证码"
            this.code_status = true;
          }
        })
      });
    },
    cutTime() {
      this.code_status = false;
      var number = 59;
      this.code_text = "重新获取(" + number + "s)";
      this.timer = setInterval(() => {
        number = number - 1;
        if (number <= 0) {
          clearInterval(this.timer);
          this.code_text = "获取验证码"
          this.code_status = true;
        } else {
          this.code_text = "重新获取(" + number + "s)";
        }
      }, 1000)
    },
    isCn() {
      return true;
    },
    checkLogin() {
      if (!this.util.getAccessToken()) {
        return false;
      }
      this.http.request({
        api: 'user/getUserInfo',
        async: 1,
        success: (res) => {
          // 登录用户变量
          var gioParams = {
            // area_ppl: (res.user.province + res.user.city) || "",//省份,城市
            // companyName_ppl: res.user.company || "",//公司名称
            // companyScale_ppl: "",//公司规模
            // email_ppl: res.user.email || "",//邮箱
            // industry_ppl: res.user.job || "",//行业
            // phone_ppl: res.user.phone || "",//手机
            // userName_ppl: res.user.username || "",//姓名
            // userRole_ppl: "",//职位
          };
          gio('people.set', gioParams);
          //登录用户ID
          gio('setUserId', res.user.id);
          //登录用户类型
          gio('track', 'loginSuccess', {
            'user_Id': res.user.memberId,  // memberId
            'phoneNumber': util.encryptPhone(res.user.phone),  //登录手机号
            'loginType': '短信' // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
          })
          // console.log(3,res.user);
          this.$store.commit('setUserInfo', res.user);
          this.util.setDellCookie();

          //临时修改
          // this.util.toBack();
          //临时修改 invitation.vue
          // var backUrl = this.tool.other.getUrlParams('backUrl');
          // if(backUrl && backUrl.indexOf('invitation') > -1){
          //     backUrl = decodeURIComponent(decodeURIComponent(backUrl));
          //     window.location = backUrl;
          // }else{
          // if(!this.util.isOffline()){
          this.util.toBack();
          // }
          // }
        }
      })
    }
  },
  mounted() {
    this.query = this.$route.query;
    //this.checkLogin();
    this.getProvince();
    this.util.showBottom(true);
    // if (this.is_offline) {
    //   document.title = "大会信息丨2024戴尔科技峰会-新·生万物 数实新格局-戴尔(Dell)企业采购网"
    // } else {
    //   document.title = "2026 戴尔科技峰会";
    // }
    document.title = "会议报名丨2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网";
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  text-align: center;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, .2);
  z-index: 99;
  background-color: #1b57c6;
  //background: url("~@/assets/image/2024/bg01.png") no-repeat center top;
  //background-size: 100%;
}

.bg {
  margin-top: 80px;
  background: #1b57c6 url("~@/assets/image/2026/register-bg.png") no-repeat top center;
  background-size: cover;
  padding-bottom: 50px;

  .top-box {
    width: 100%;
    height: 360px;
    background: url("~@/assets/image/2026/register-kv.png") no-repeat top center;
    background-size: auto 100%;
  }

  .register-box {
    width: 960px;
    background: #fff;
    margin: 10px auto 0;
    border-radius: 5px;
    padding-bottom: 50px;

    .title {
      height: 70px;
      line-height: 70px;
      text-align: center;
      font-size: 18px;
      border-bottom: 2px solid #f6f6f6;
      position: relative;
      margin-bottom: 34px;
    }

    .title::after {
      content: "";
      position: absolute;
      display: block;
      bottom: -2px;
      left: 50%;
      width: 150px;
      height: 4px;
      margin-left: -75px;
      background: #1a56c6;
    }

    .item-wrap {
      clear: both;

      .validate {
        margin-left: 110px;
      }
    }

    .item {
      width: 830px;
      margin: 0 auto;

      .tit {
        width: 120px;
        padding-right: 10px;
        font-size: 14px;
        line-height: 20px;

        .middle {
          height: 40px;
          width: 120px;
          text-align: right;

          i {
            color: #ff0000;
            margin-right: 2px;
          }
        }
      }

      .input {
        width: 630px;
        position: relative;

        .in {
          display: block;
          width: 600px;
          height: 40px;
          padding: 0 15px;
          font-size: 14px;
          border-radius: 5px;
          background: #fafafa;
          border: 1px solid #f1f1f1;
        }

        .in.error {
          border-color: red;
        }

        .input-select {
          position: absolute;
          left: 0;
          top: 40px;
          width: 100%;
          height: 200px;
          overflow: hidden;
          overflow-y: auto;
          z-index: 99;
          background: #fff;
          border: 1px solid #f1f1f1;

          .select-options {
            .item {
              height: 40px;
              line-height: 40px;
              padding: 0 14px;
              overflow: hidden
            }

            .item:hover, .item.active {
              background: #fafafa;
            }
          }

          .loading {
            display: flex;
            height: 100%;
            position: relative;
            justify-content: center;
            align-items: center;
          }
        }
      }

      .input.error {
        border: 1px solid red;
        box-sizing: border-box;
        border-radius: 5px;
      }

      .input.code {
        .in {
          width: 440px;
        }

        .btn {
          display: block;
          float: right;
          width: 150px;
          font-size: 14px;
          border-radius: 5px;
          text-align: center;
          line-height: 42px;
          background: #1a56c6;
          color: #fff;
          cursor: pointer;
          transition: all .3s ease;
        }

        .btn:hover {
          color: rgb(200, 200, 200);
        }

        .btn.hidden {
          background: #999999;
          cursor: auto;
        }

        .btn.hidden:hover {
          color: #fff;
        }
      }

      .validate {
        clear: both;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        color: red;
      }
    }

    .item.item-check {
      .ll {
        width: 630px;
        padding-top: 5px;

        label {
          display: block;
          float: left;
          margin-right: 30px;
          height: 30px;
          line-height: 30px;
          cursor: pointer;

          input {
            margin-right: 5px;
            display: none;
          }

          span {
            display: block;
            float: left;
          }

          input[type=checkbox] + i {
            display: block;
            float: left;
            width: 30px;
            height: 30px;
            background: url("~@/assets/image/a4.png") no-repeat center center;
            background-size: 22px;
            transition: all .3s ease;
          }

          input[type=checkbox]:checked + i {
            background: url("~@/assets/image/2024/check1.png") no-repeat center center;
            background-size: 22px;
            transition: all .3s ease;
          }
        }
      }

      .validate {
        margin-left: 130px;
      }

      .forum-list {
        display: flex;
        flex-wrap: wrap;

        .li {
          //width: calc((100% - 12px) / 2);
          //margin-right: 12px;
          margin-bottom: 12px;
          padding: 12px;
          border: 1px solid #666666;
          border-radius: 10px;
          box-sizing: border-box;
          cursor: pointer;

          &.error {
            border: 1px solid red;
          }

          .text {
            font-weight: bold;
            font-size: 16px;
            white-space: pre-wrap;
          }

          .desc {
            margin-top: 5px;
            font-size: 14px;
            white-space: pre-line;
          }
          .tips {
            margin-top: 5px;
            font-size: 14px;
            color: #000;
          }
        }

        .li.active {
          border-color: #1a56c6;
          background: #1a56c6;
          color: #fff;
          .tips {
            color: #fff;
          }
        }

        .li:first-child {
          width: 100%;
          margin-right: 0;
        }

        .li:nth-last-child(1) {
          //width: 100%;
          //width: calc((100% - 12px) / 2);
          margin-right: 0;
        }

        //.li:nth-child(2n) {
        //  margin-right: 0;
        //  width: calc((100% - 12px) / 2);
        //}
      }

      .forum-list.active {
        display: block;

        .li {
          width: 100%;
          margin-right: 0;
        }
      }
    }

    .item.error {
      .input {
        .in {
          border-color: red;
        }
      }
    }

    .item.item-m {
      float: left;
      width: 375px;

      .tit {
        width: 105px;
      }

      .input {
        width: 255px;

        .in {
          width: 230px;
        }
      }
    }

    .item.item-m.item-left {
      padding-left: 80px;
    }

    .item.item-select {
      .validate {
        margin-left: 130px;
      }
    }

    .item.item-lang {
      .tit {
        float: none;
        width: 100%;
        margin-left: 130px;

        .middle {
          width: 100%;
          height: 30px;
        }
      }

      .input {
        float: none;
        margin-left: 130px;
      }

      .validate {
      }
    }

    .check-box {
      padding-left: 80px;
      width: 640px;
      margin: 0 auto;

      .tit {
        font-size: 15px;
        line-height: 21px;

        .red {
          color: red;
          margin-right: 2px;
        }
      }

      .check {
        overflow: hidden;
        margin-top: 10px;

        label {
          margin-right: 50px;
          height: 30px;
          line-height: 30px;
          cursor: pointer;
          overflow: hidden;
          display: block;
          float: left;

          input {
            margin-right: 10px;
            width: 18px;
            height: 18px;
            float: left;
            margin-top: 5px;
            display: none;
          }

          input[type=radio] + i {
            display: block;
            float: left;
            width: 30px;
            height: 30px;
            background: url("~@/assets/image/a2.png") no-repeat center center;
            background-size: 22px;
            transition: all .3s ease;
          }

          input[type=radio]:checked + i {
            background: url("~@/assets/image/2024/mobile/radio1.png") no-repeat center center;
            background-size: 22px;
            transition: all .3s ease;
          }

          span {
            display: block;
            float: left;
          }
        }
      }

      .validate {
        clear: both;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        color: red;
      }
    }

    .rule-box {
      padding-left: 80px;
      width: 640px;
      margin: 0 auto 24px;

      .tit {
        font-size: 15px;
        line-height: 30px;
        overflow: hidden;

        input {
          margin-right: 5px;
          cursor: pointer;
          width: 18px;
          height: 18px;
          margin-top: 5px;
          float: left;
          display: none;
        }

        span {
          display: block;
          float: left;
          width: 600px;
        }

        i {
          color: #0176ce;
          text-decoration: underline !important;
          cursor: pointer;
        }

        input[type=checkbox] + .i {
          display: block;
          float: left;
          width: 30px;
          height: 30px;
          background: url("~@/assets/image/a4.png") no-repeat center center;
          background-size: 22px;
          transition: all .3s ease;
        }

        input[type=checkbox]:checked + .i {
          background: url("~@/assets/image/2024/check1.png") no-repeat center center;
          background-size: 22px;
          transition: all .3s ease;
        }

        .red {
          color: red;
          text-decoration: none !important;
          cursor: default;
          margin-right: 2px;
        }
      }

      .validate {
        clear: both;
        padding-left: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        color: red;
      }
    }

    .submit {
      width: 362px;
      margin: 30px auto;
      height: 45px;
      line-height: 45px;
      text-align: center;
      color: #fff;
      font-size: 18px;
      background: #1a56c6;
      border-radius: 5px;
      box-shadow: 0 0 10px 5px rgba(1, 118, 206, .1);
      cursor: pointer;
      transition: all .3s ease;
    }

    .submit:hover {
      color: rgb(200, 200, 200);
      transition: all .3s ease;
    }
  }
}

.book-success {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  .mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .8);
  }

  .content {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 750px;
    height: 390px;
    background: url("~@/assets/image/2026/success-kv.png") no-repeat center center;
    background-size: cover;
    color: #fff;
    margin-left: -375px;
    margin-top: -195px;
    border-radius: 10px;

    .close {
      width: 50px;
      height: 50px;
      position: absolute;
      top: 0;
      right: 0;
      background: url("~@/assets/image/54.png") no-repeat center center;
      background-size: 20px;
      cursor: pointer;
      transition: background .3s ease;
    }

    .close:hover {
      background-image: url("~@/assets/image/53.png");
      background-size: 20px;
      transition: background .3s ease;
    }

    .middle {
      width: 750px;
      height: 390px;
      text-align: center;
      color: #ffffff;

      .title {
        font-size: 34px;
        font-weight: bold;
      }

      .m-title {
        font-size: 20px;
        margin-top: 15px;
        line-height: 1.5;
      }

      .qrcode-box {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;

        .qrcode {
          width: 130px;
          height: 130px;
          display: block;
        }

        .info {
          font-size: 20px;
          margin-left: 15px;
          text-align: left;
        }
      }

      .btn-group {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;

        .btn {
          margin-right: 100px;
        }

        .btn:nth-last-child(1) {
          margin-right: 0;
        }
      }

      .btn {
        width: 140px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #0b32a9;
        cursor: pointer;
        border-radius: 5px;
        background: #3bcfda;
        font-size: 20px;
      }

      .btn.btn-l {
        width: 160px;
      }
    }
  }
}
</style>

